var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "signature",
      class: { selected: _vm.selected, positioned: _vm.positioned },
      on: {
        click: function($event) {
          return _vm.$emit("click")
        }
      }
    },
    [
      _vm.closable
        ? _c(
            "div",
            {
              staticClass: "button-close",
              on: {
                click: function($event) {
                  $event.stopPropagation()
                  return _vm.$emit("close")
                },
                touchstart: function($event) {
                  $event.stopPropagation()
                  return _vm.$emit("close")
                }
              }
            },
            [_vm._v(" x ")]
          )
        : _vm._e(),
      _c("div", [
        _c("div", { staticClass: "stamp" }),
        _c("div", { staticClass: "data" }, [
          _c(
            "div",
            [
              _vm.name
                ? _c("div", { staticClass: "data-item" }, [
                    _vm._v(" " + _vm._s(_vm.name) + " "),
                    _vm.positioned
                      ? _c(
                          "span",
                          { staticClass: "text-warning" },
                          [_c("vs-icon", { attrs: { icon: "approval" } })],
                          1
                        )
                      : _vm._e()
                  ])
                : _vm._e(),
              _vm._t("default")
            ],
            2
          )
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }